/**
 * Export component file to be used on project
 */

import EmailRecover from './EmailRecover';
export default EmailRecover;